import { LOANS_URLS } from './endpoints.constants';

const API_URL = process.env.API_URL;

const ENDPOINTS_LOANS = {
  get: {
    serviceClosed: () => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.SERVICE_CLOSED}`,
    creditworthiness: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${employeeId}/${LOANS_URLS.CREDITWORTHINESS_ROOT}`,
    modalities: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${employeeId}/${LOANS_URLS.MODALITIES_ROOT}`,
    myLoans: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${employeeId}/${LOANS_URLS.MY_LOANS_ROOT}`,
    familiesNeedALoan: () => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.FAMILIES}`,
    dataEuribor: () => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.EURIBOR}`,
    dataSV: () => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.FIXED_SV}`,
    dataVC: () => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.FIXED_VC}`,
    wageAdvanceReasonsList: () => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.WAGE_ADVANCE_REASONS_LIST}`,
    employeeWagesAdvance: employeeId => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.WAGE_ADVANCE_EMPLOYEE}/${employeeId}/list`,
  },
  post: {
    createLoan: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${employeeId}/${LOANS_URLS.SIGN_UP_ROOT}`,
    createPartialRepayment: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.REPAYMENT_ROOT}/partial/${employeeId}`,
    simulateRepayment: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.REPAYMENT_ROOT}/simulate/${employeeId}`,
    createTotalRepayment: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.REPAYMENT_ROOT}/total/${employeeId}`,
    createSimulation: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${employeeId}/${LOANS_URLS.SIMULATION_ROOT}`,
    createWageAdvance: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.WAGE_ADVANCE_EMPLOYEE}/${employeeId}`,
    requestNovation: employeeId => `${API_URL}/${LOANS_URLS.ROOT}/${employeeId}/${LOANS_URLS.SIGN_UP}`
  },
  put: {
    modifyCadastralReference: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${employeeId}/${LOANS_URLS.CADASTRAL_REFERENCE}`,
  },
  delete: {
    amortization: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.REPAYMENT_ROOT}/${employeeId}`,
    deleteWageAdvance: (employeeId) => `${API_URL}/${LOANS_URLS.ROOT}/${LOANS_URLS.WAGE_ADVANCE_EMPLOYEE}/${employeeId}`,
  },
};

export {
  ENDPOINTS_LOANS
};



// WEBPACK FOOTER //
// ./client/app/common/endpoints/loans.endpoints.js